export const getCharacterCount = (str: string): number => {
  return [...str].length;
};

export const replaceURLWithLinks = (str: string): string => {
  const urlRegex = /((https?:\/\/)[^\s]+)/g;
  return str.replace(urlRegex, '<a href="$1">$1</a>');
};

export const newLineToBR = (str: string): string => {
  return str.replace(/\n/g, "<br />");
};
